import React from 'react';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiMetrics = () => {
  const { metrics } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-white px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[120px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal>
          <h2 className="text-[32px] font-bold leading-none text-[#0b0b0b] md:text-4xl xl:text-[48px]">
            {metrics.title}
          </h2>
        </GenAiReveal>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {metrics.items.map((item, index) => (
            <GenAiReveal key={item.id} delay={index * 80}>
              <article className="flex h-full flex-col gap-7 rounded-3xl bg-[#ecebf2] p-7 shadow-[0_8px_8px_rgba(29,22,29,0.02)]">
                <div className="size-[79px] overflow-hidden rounded-3xl">
                  <img
                    src={item.icon}
                    alt=""
                    className="h-full w-full object-contain object-bottom"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold leading-[1.1] text-[#0b0b0b] md:text-2xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-[1.3] text-[#2f2f2f]/80">
                    {item.description}
                  </p>
                </div>
              </article>
            </GenAiReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GenAiMetrics;
